import PropTypes from "prop-types";

import logo from "../assets/inova-logo-light.svg";

const Logo = ({
	imgClass,
	className,
	style
}) => (
	<div className={`logo-container ${className}`}>
		<img
			alt="Logo"
			className={imgClass}
			id="logo"
			src={logo}
			style={style}
		/>
	</div>
);

Logo.propTypes = {
	className: PropTypes.string,
	imgClass: PropTypes.string,
	style: PropTypes.shape({})
};

Logo.defaultProps = {
	className: "",
	imgClass: "",
	style: {
		width: "200px"
	}
};

export default Logo;
